import React from 'react';
import { BaseIcon } from './BaseIcon';

export const LightIcon = ({ ...props }) => {
    return <BaseIcon iconType="fal" {...props} />;
};

LightIcon.propTypes = BaseIcon.propTypes;
